<template>
    <div v-clickaway="closeMenu" :class="menuClass">
        <button type="button" class="app-user-menu__name" @click="toggleMenu">
            <div class="app-user-menu__avatar">
                <common-user-avatar
                    :user="$auth.getUser()"
                    :isCurrent="$auth.isUserPhysician()"
                    size="user-menu"
                ></common-user-avatar>
            </div>

            <common-user-name class="app-user-menu__fullname" :user="$auth.getUser()" size="user-menu"></common-user-name>
        </button>

        <app-user-dropdown
            :isOpen="isDropdownShown"
            :isOnlyLogoutAvailable="isOnlyLogoutAvailable"
            @emitEvent="emitEvent($event)"
        ></app-user-dropdown>
    </div>
</template>

<script>
    import AppUserDropdown from 'components/layouts/app-layout/AppUserDropdown'

    export default {
        components: {
            AppUserDropdown,
        },

        props: {
            isOnlyLogoutAvailable: { type: Boolean, default: false },
        },

        data() {
            return {
                isDropdownShown: false,
            }
        },

        computed: {
            menuClass() {
                return {
                    'app-user-menu': true,
                    'app-user-menu--is-open': this.isDropdownShown,
                }
            },
        },

        methods: {
            toggleMenu() {
                this.isDropdownShown = !this.isDropdownShown
            },

            closeMenu() {
                this.isDropdownShown = false
            },
        },
    }
</script>
